import {SubjectType as SubjectTypeContract} from '@esgi/contracts/esgi/types/esgi.enums/subject-type';
import {SubjectType} from '@esgi/main/libs/store';

export const adaptedSubjectTypeWithContracts: Record<SubjectType, SubjectTypeContract> = {
	[SubjectType.Personal]: SubjectTypeContract.Personal,
	[SubjectType.Stock]: SubjectTypeContract.Stock,
	[SubjectType.Deployed]: SubjectTypeContract.Deployed,
};
